export function configuredApiBaseUrl() {
  return (import.meta.env.VITE_API_BASE_URL || '/api/v1').replace(/\/$/, '')
}

export function configuredApiOrigin(browserOrigin = globalThis.location?.origin || 'https://localhost', apiBaseUrl = configuredApiBaseUrl()) {
  const url = new URL(apiBaseUrl, browserOrigin)
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password) throw new Error('Invalid API base URL.')
  return url.origin
}

// API-owned assets are served by the API host; bundled UI assets and explicitly
// configured external HTTPS logos retain their existing URL policy.
export function resolveApiAssetUrl(value, browserOrigin = globalThis.location?.origin || 'https://localhost') {
  return value.startsWith('/api/') ? new URL(value, configuredApiOrigin(browserOrigin)).href : value
}
